import { Dropdown, Icon, Menu } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { setUserLogout } from '../../core-module/redux/Auth/actions';
import { DefaultAuthState } from '../../core-module/models/redux/DefaultAuthState';
import ChangePasswordForm from '../CrudForms/ChangePasswordForm';
import LoopBackEndpoint from '../../core-module/models/LoopBack/Models/LoopBackEndpoint';
import UserEndpoint from '../../core-module/models/LoopBack/Models/UserEndpoint';
import { formatFullDriverName } from '../../core-module/helpers/nameFormatting';

interface Props {
  setUserLogout: typeof setUserLogout;
  auth: DefaultAuthState;
}

interface State {
  visible: boolean;
}

class ProfileMenu extends React.Component<Props, State> {
  private readonly loopBackEndpoint: LoopBackEndpoint;

  constructor(props) {
    super(props);
    this.loopBackEndpoint = new UserEndpoint();
    this.state = {
      visible: false
    };
  }

  logout = () => {
    this.props.setUserLogout();
  };

  showChangePasswordPopup = () => {
    this.setState({ visible: true });
  };

  hidePopup = () => {
    this.setState({ visible: false });
  };

  menu = () => (
    <Menu>
      <Menu.Item key='0'>
        <button className='href' onClick={this.showChangePasswordPopup}>
          Wachtwoord wijzigen
        </button>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key='1'>
        <button className='href' onClick={this.logout}>
          Uitloggen
        </button>
      </Menu.Item>
    </Menu>
  );

  render() {
    return (
      <div>
        <Dropdown overlay={this.menu()} trigger={['click']}>
          <button className='ant-dropdown-link href' style={{ color: '#585663' }}>
            {this.props.auth.user && (
              <span>
                <Icon type='user' /> {formatFullDriverName(this.props.auth.user.driver!)}{' '}
                <Icon type='down' />
              </span>
            )}
          </button>
        </Dropdown>
        <ChangePasswordForm
          loopBackEndpoint={this.loopBackEndpoint}
          visible={this.state.visible}
          onCancel={this.hidePopup}
        />
      </div>
    );
  }
}

const mapPropsToDispatch = (props) => ({
  auth: props.auth
});

const mapDispatchToProps = (dispatch) => ({
  setUserLogout: () => {
    dispatch(setUserLogout());
  }
});

export default connect<any, any, any>(mapPropsToDispatch, mapDispatchToProps)(ProfileMenu);
